<template>
    <CTable
        :isLoading="isLoading"
        v-model:columns="state.columns"
        v-model:page="state.page"
        :options="state.tableOptions"
        :manages="state.manages"
        :manageExtras="state.manageExtras"
        :rowActions="state.rowActions"
        @search="search => onSearch({ props, state, companyId, ...search })"
    ></CTable>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../../app.logic";
import { initState, isLoading, onSearch } from "./tab2.logic";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "company-mgt-tab-2-1" }
    },
    setup(props) {
        const route = useRoute();
        const companyId = route.params?.companyId;
        const state = reactive(initState({ props, companyId }));
        return { props, isLoading, state, onSearch, companyId };
    }
});
</script>
